import React from 'react';

const Home = () => {
  return (
    <div style={styles.container}>
      {/* Banner superior */}
      <div style={styles.bannerContainer}>
        <img src="Impulsor.jpg" alt="Banner Institucional" style={styles.bannerImage} />
      </div>

      {/* Sección de Carrusel de Planteles */}
      <h2 style={styles.sectionTitle}>Planteles</h2>
      <div className="carrusel">
        <div className="carrusel-imagenes">
          <img src="plantelTula.png" alt="TULA HGO." />
          <img src="plantel1.png" alt="Plantel 1" />
          <img src="plantel2.png" alt="Plantel 2" />
        </div>
      </div>

      {/* Secciones Informativas */}
      <section style={styles.seccionInfo}>
        <h2 style={styles.tituloCentrado}>Instalaciones</h2>
        <p style={styles.textoFormal}>
          Nuestras instalaciones cuentan con el espacio adecuado para que los alumnos realicen sus actividades académicas con comodidad.
        </p>
      </section>

      <section style={styles.seccionInfo}>
        <h2 style={styles.tituloCentrado}>Excelencia Académica</h2>
        <p style={styles.textoFormal}>
          Grupo Impulsor Educativo tiene más de 30 años formando profesionistas competentes, comprometidos con su turno social.
        </p>
      </section>

      {/* Footer */}
      <footer style={styles.footer}>
        <div style={styles.footerContent}>
          <p style={styles.footerTextCenter}>
            <strong>Instituto Grupo Impulsor Educativo</strong><br />
            <a
              href="https://maps.google.com/?q=Calzada Melchor Ocampo 204"
              target="_blank"
              rel="noopener noreferrer"
              style={styles.footerLink}
            >
              Calzada Melchor Ocampo 204
            </a>
          </p>

          <div style={styles.contactRow}>
            <p>Teléfono: 773-134-56-39 / 773-732-76-04</p>
            <p>Correo: grupoimpulsoreducativotula@gmail.com</p>
          </div>

          <div style={styles.socialIconsClean}>
          
            {/* Facebook */}
            <a href="https://www.facebook.com/share/19RskfDHie/" target="_blank" rel="noreferrer">
              <img
                src="https://cdn-icons-png.flaticon.com/512/733/733547.png"
                alt="Facebook"
                style={styles.socialIcon}
              />
            </a>

            {/* Instagram */}
            <a href="https://www.instagram.com/grupo_impulsor_educativo" target="_blank" rel="noreferrer">
              <img
                src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png"
                alt="Instagram"
                style={styles.socialIcon}
              />
            </a>

            {/* TikTok */}
            <a href="https://www.tiktok.com/@grupo_impulsor_educativo?is_from_webapp=1&sender_device=pc" target="_blank" rel="noreferrer">
              <img
                src="https://cdn-icons-png.flaticon.com/512/3046/3046122.png"
                alt="TikTok"
                style={styles.tiktokIcon}
              />
            </a>
          </div>

          <p style={styles.footerTextCenter}>
            Todos los derechos reservados a grupoimpulsoreducativo 2025
          </p>
        </div>
      </footer>

      {/* CSS estilo carrusel lento tipo loop ping-pong */}
      <style>{`
        .carrusel {
          overflow: hidden;
          max-width: 99%;
          margin: 80px auto;
          display: flex;
          justify-content: center;
        }

        .carrusel-imagenes {
          display: flex;
          animation: deslizarPingPong 80s ease-in-out infinite;
          gap: 15px;
        }

        .carrusel-imagenes img {
          width: 300px;
          height: 300px;
          object-fit: cover;
          border-radius: 3px;
          box-shadow: 0 9px 9px rgba(0,0,0,0.2);
        }

        @keyframes deslizarPingPong {
          0% { transform: translateX(0); }
          110% { transform: translateX(-20%); }
          100% { transform: translateX(0); }
        }
      `}</style>
    </div>
  );
};

const styles = {
  container: {
    fontFamily: "'Montserrat', sans-serif",
    backgroundColor: '#f5f5f5',
    color: '#1e1e1e',
    textAlign: 'center',
    position: 'relative',
  },
  bannerContainer: {
    width: '100%',
    marginBottom: '30px',
    marginTop: '20px',
  },
  bannerImage: {
    width: '100%',
    height: 'auto',
    borderRadius: '8px',
    boxShadow: "0 -12px 30px rgba(115, 170, 230, 0.5), 0 8px 20px rgba(0, 123, 255, 0.3)",
  },
  sectionTitle: {
    fontSize: '28px',
    marginBottom: '20px',
    color: '#2c3e50',
  },
  seccionInfo: {
    margin: '60px 20px',
  },
  tituloCentrado: {
    fontSize: '26px',
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: '20px',
    color: '#2c3e50',
  },
  textoFormal: {
    fontSize: '16px',
    color: '#444',
    maxWidth: '800px',
    margin: '0 auto',
    lineHeight: '1.7',
    textAlign: 'center',
  },
  footer: {
    background: 'linear-gradient(to right, #1786a0, #0f2d45)',
    color: '#fff',
    padding: '0px 10px',
    fontSize: '14px',
    width: '99%',
  },
  footerContent: {
    maxWidth: '700px',
    margin: '0 auto',
    textAlign: 'center',
    fontFamily: "'Montserrat', sans-serif",
  },
  footerTextCenter: {
    margin: '10px 0',
    lineHeight: '1.6',
  },
  footerLink: {
    color: '#ffffff',
    textDecoration: 'underline',
  },
  contactRow: {
    display: 'flex',
    justifyContent: 'space-around',
    flexWrap: 'wrap',
    gap: '10px',
    margin: '20px 0',
  },
  socialIconsClean: {
    display: 'flex',
    justifyContent: 'center',
    gap: '25px',
    margin: '20px 0 15px 0',
  },
  socialIcon: {
    width: '30px',
    height: '30px',
  },
  tiktokIcon: {
    width: '30px',
    height: '30px',
    filter: 'brightness(5)',
  },
};

export default Home;
